import { UiSkinKey } from './skin.type'

export const DEFAULT_UI_SKIN_KEY: UiSkinKey = 'v1'

export const UI_SKIN_KEYS: readonly UiSkinKey[] = ['v1', 'v2', 'v3']

export const UI_SKIN_BODY_CLASS_BY_KEY: Record<UiSkinKey, string> = {
	v1: 'ui-skin-v1',
	v2: 'ui-skin-v2',
	v3: 'ui-skin-v3',
}

export const UI_SKIN_BODY_CLASSES = Object.values(UI_SKIN_BODY_CLASS_BY_KEY)

export function resolveUiSkinKey(uiSkinKey?: string): UiSkinKey {
	const normalizedSkinKey = uiSkinKey?.trim()
	return UI_SKIN_KEYS.includes(normalizedSkinKey as UiSkinKey) ? (normalizedSkinKey as UiSkinKey) : DEFAULT_UI_SKIN_KEY
}
